import PageLayout from './PageLayout';

export default PageLayout;



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/Bulletin/Components/PageLayout/index.ts